<!-- Loader -->
<ng-container *ngIf="isLoading$ | async ; else template">
  <section class="sg-product">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-3">
              <div class="sg-img">
                <!-- Tab panes -->
                <div style="border: none !important;" class="tab-content">

                  <ngx-skeleton-loader animation="progress" animation="true" appearance="line" [theme]="theme">
                  </ngx-skeleton-loader>

                </div>

              </div>
            </div>
            <div class="col-md-4" style="border-right: 1px solid #e5e5e5!important;">
              <div class="sg-content">

                <div class="pro-name">
                  <ngx-skeleton-loader animation="progress" appearance="line"
                                       [theme]="{ margin: '5px 0 0 0px', width: '300px', height: '30px',background: '#f1f1f1'}">
                  </ngx-skeleton-loader>
                </div>

                <div class="pro-tag">
                  <ngx-skeleton-loader animation="progress" appearance="line"
                                       [theme]="{ margin: '5px 0 0 0px', width: '250px', height: '60px',background: '#f1f1f1'}">
                  </ngx-skeleton-loader>
                </div>

                <div style="padding-top: 5px;" class="pro-rating">
                  <ngx-skeleton-loader animation="progress" appearance="line"
                                       [theme]="{ margin: '5px 0 0 0px', width: '150px', height: '20px',background: '#f1f1f1'}">
                  </ngx-skeleton-loader>
                </div>

                <div class="colo-siz">

                  <div class="pro-btns">
                    <ngx-skeleton-loader animation="progress" appearance="line"
                                         [theme]="{ margin: '5px 0 0 0px', width: '110px', height: '30px',background: '#f1f1f1'}">
                    </ngx-skeleton-loader>
                  </div>

                </div>

              </div>
            </div>
            <div class="col-md-5">
              <div class="sg-content">

                <div class="pro-tag">
                  <ngx-skeleton-loader animation="progress" appearance="line"
                                       [theme]="{ margin: '5px 0 0 0px', width: '300px', height: '30px',background: '#f1f1f1'}">
                  </ngx-skeleton-loader>
                </div>

                <div style="padding-top: 3px" class="pro-tag">
                  <ngx-skeleton-loader animation="progress" appearance="line"
                                       [theme]="{ margin: '5px 0 0 0px', width: '250px', height: '20px',background: '#f1f1f1'}">
                  </ngx-skeleton-loader>
                </div>

                <div style="padding-top: 3px" class="pro-tag">
                  <ngx-skeleton-loader animation="progress" appearance="line"
                                       [theme]="{ margin: '5px 0 0 0px', width: '240px', height: '20px',background: '#f1f1f1'}">
                  </ngx-skeleton-loader>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</ng-container>
<!-- End Loader -->

<ng-template #template>
  <section class="sg-product">
    <div *ngIf="data$ | async as product" class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-3">
              <div class="sg-img">
                <!-- Tab panes -->
                <div class="tab-content">

                  <ngx-skeleton-loader [hidden]="product.loaded" animation="progress" appearance="line" [theme]="theme">
                  </ngx-skeleton-loader>

                  <ng-container>
                    <div [hidden]="!product.loaded" class="tab-pane fade show active" id="sg10" role="tabpanel">
                      <img [hidden]="!product.loaded"
                           src="{{product.pictures.length>0?product.pictures[0].previewUrl:'assets/xemart/images/notImg.png' }}"
                           (load)="product.loaded=true" class="img-fluid">
                    </div>
                  </ng-container>

                  <div class="nav d-flex">
                    <a *ngFor="let img of product.pictures; let index = index;" class="nav-item nav-link mx-1" data-toggle="tab" href="javascript:void(0)" (click)="showActive(index,product.pictures.length)">
                      <img id="itemImg{{index}}" src="{{img.imageUrl}}" alt="">
                    </a>
                  </div>

                </div>

              </div>
            </div>
            <div class="col-md-4" style="border-right: 1px solid #e5e5e5!important;">
              <div class="sg-content">

                <div class="pro-name">
                  <p>{{product.name}}</p>
                </div>

                <div class="pro-tag">
                  <p style="padding-top: 5px;" align="left | right | center | justify">
                    {{product.rankingToShow}}
                  </p>
                </div>

                <div style="padding-top: 5px;" class="pro-rating">
                  <ul title="{{product.rating}}" [innerHtml]="product.rating | start" class="list-unstyled list-inline"></ul>
                </div>
              </div>
            </div>
            <div class="col-md-5">
              <div class="sg-content">
                <div style="padding-top: 3px" class="pro-tag">
                  <p><i style="padding-right:3px;" class="fa fa-pencil-square-o"></i> Descripción:</p>
                  <div style="padding-left: 10px;" class="tab-pane fade show active" id="pro-det" role="tabpanel">
                    <p><i style="padding-right:3px;" class="fa fa-check"></i>{{product.description}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <section class="category pt-4">
            <div class="container">
              <div class="row">
                <div class="col-md-12 px-0">
                  <div class="product-box">
                    <div class="view">
                      <div *ngIf="product" class="sg-tab mt-3">
                        <ul ngbNav #nav="ngbNav" class="nav-tabs">
                          <li class="d-flex" ngbNavItem>
                            <a  class="pr-2" ngbNavLink>
                              Productos</a>(<a class="pr-0" style="color: #5677fc;text-transform: none;" routerLink="productos">Todos</a>)
                            <ng-template ngbNavContent>
                              <div class="row">
                                <div *ngFor="let item of product.productSection.products; let index = index;"
                                     style="display:flex;" class="col-lg-3 col-md-6">
                                  <div id="{{item.code}}" class="tab-item">
                                    <div class="tab-img">
                                      <ngx-skeleton-loader [hidden]="item.loaded" animation="progress"
                                                           appearance="line"
                                                           [theme]="theme">
                                      </ngx-skeleton-loader>
                                      <img [hidden]="!item.loaded" class="main-img img-fluid"
                                           src="{{item.pictures .length>0?item.pictures[0].previewUrl:'assets/xemart/images/notImg.png'}}"
                                           (load)="item.loaded=true">

                                    </div>
                                    <div class="tab-heading">
                                      <p>
                                        <a routerLink='../../productos-compras-cuba-online/cubatel/{{item.code}}'>{{item.name}}</a>
                                      </p>
                                    </div>
                                    <div class="img-content d-flex justify-content-between">
                                      <div>
                                        <ul title="{{item.rating}}" [innerHtml]="item.rating | start"
                                            class="list-unstyled list-inline fav"></ul>
                                        <ul class="list-unstyled list-inline price">
                                          <li class="list-inline-item">{{item.priceToShow}}</li>
                                          <li class="list-inline-item">{{item.oldPriceToShow}}</li>
                                        </ul>
                                      </div>
                                      <div>
                                        <a (click)="pushToCart(item)" href="javascript:void(0)" data-toggle="tooltip" data-placement="top" title="Añadir al carrito">
                                          <i class="fa fa-shopping-cart"></i>
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                          </li>
                          <!--<li ngbNavItem>
                            <a ngbNavLink>
                              Reviews
                            </a>
                            <ng-template ngbNavContent>
                              <p>Consectetur adipisicing elit. Dignissimos a deleniti dolorem architecto quae eligendi
                                voluptatem
                                omnis beatae at aut eveniet repellendus voluptas.</p>
                            </ng-template>
                          </li>-->
                        </ul>
                        <div [ngbNavOutlet]="nav" class="mt-2"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </div>
      </div>
    </div>
  </section>
</ng-template>
